import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../../css/ClassPaymentStatus.css";

class ClassPaymentSuccess extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleBackToClasses = () => {
    // Send user back to the 4 services classes page as requested
    this.props.history.push("/classes");
  };

  handleGoDashboard = () => {
    this.props.history.push("/user/userDashboard");
  };

  render() {
    const state = (this.props.location && this.props.location.state) || {};
    const paymentId = state.paymentId || state.payment_id || "pay_verified";
    const orderId = state.orderId || state.order_id || "Order Confirmed";
    const services = state.services || "Online Fitness Classes";
    const duration = state.duration ? `${state.duration} Months` : "12 Months";
    const amount = state.amount ? `₹${state.amount}` : "Paid";

    // Calculate expiry date display
    const monthsToAdd = state.duration ? Number(state.duration) : 12;
    const expiry = new Date();
    expiry.setMonth(expiry.getMonth() + monthsToAdd);
    const expiryStr = expiry.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

    return (
      <div className="cps-page-wrapper">
        <div className="cps-container">
          <div className="cps-card">
            {/* Success Animated Icon */}
            <div className="cps-icon-wrap cps-icon-success">
              <svg
                width="42"
                height="42"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>

            <span className="cps-badge cps-badge-success">Payment Confirmed</span>
            <h1 className="cps-title">Membership Activated! 🎉</h1>
            <p className="cps-subtitle">
              Thank you for subscribing to Fitfinity Live Classes. Your membership is now active and ready to use.
            </p>

            {/* Details Box */}
            <div className="cps-details-box">
              <div className="cps-detail-row">
                <span className="cps-detail-label">Classes Enrolled</span>
                <span className="cps-detail-value highlight-gold">{services}</span>
              </div>
              <div className="cps-detail-row">
                <span className="cps-detail-label">Duration</span>
                <span className="cps-detail-value">{duration}</span>
              </div>
              <div className="cps-detail-row">
                <span className="cps-detail-label">Amount Paid</span>
                <span className="cps-detail-value highlight-green">{amount} (incl. GST)</span>
              </div>
              <div className="cps-detail-row">
                <span className="cps-detail-label">Payment ID</span>
                <span className="cps-detail-value">{paymentId}</span>
              </div>
              {orderId && (
                <div className="cps-detail-row">
                  <span className="cps-detail-label">Order ID</span>
                  <span className="cps-detail-value">{orderId}</span>
                </div>
              )}
              <div className="cps-detail-row">
                <span className="cps-detail-label">Valid Until</span>
                <span className="cps-detail-value">{expiryStr}</span>
              </div>
            </div>

            {/* Instruction Banner */}
            <div className="cps-info-banner">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
              <div className="cps-info-banner-text">
                <strong>Next Step: Daily Class Links</strong>
                Live session joining links & schedule will be shared directly on your registered WhatsApp / Mobile.
              </div>
            </div>

            {/* Actions */}
            <div className="cps-actions">
              <button
                type="button"
                className="cps-btn-primary"
                onClick={this.handleBackToClasses}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                Back to Classes
              </button>

              <button
                type="button"
                className="cps-btn-secondary"
                onClick={this.handleGoDashboard}
              >
                View in My Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ClassPaymentSuccess);
